import React from 'react';

export function SoundWave() {
  const bars = Array.from({ length: 10 });

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'center',
      height: '3rem',
      margin: '10px',
      width: '100%',
      backgroundColor: 'rgba(30, 41, 59, 0.7)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.4)',
      borderRadius: '12px'
    }}>
      <style>
        {`
            @keyframes pulse {
              0% { height: 10%; }
              25% { height: 50%; }
              50% { height: 15%; }
              75% { height: 80%; }
              100% { height: 10%; }
            }
          `}
      </style>
      {bars.map((_, i) => (
        <div
          key={i}
          style={{
            width: '5px',
            background: 'linear-gradient(to top, #3b82f6, #60a5fa)',
            animation: `pulse 1s ease-in-out infinite`,
            animationDelay: `${Math.random().toFixed(2)}s`,
            borderRadius: '4px',
          }}
        />
      ))}
    </div>
  );
}
